import type { EventPageData } from "./eventPage.ts";
import { eventPageUiTexts } from "./eventPageTexts.ts";
import type { Language } from "./texts.ts";

declare global {
  var __EVENT_DATA__: EventPageData | null | undefined;
  var __EVENT_LANG__: Language | undefined;
}

export const defaultTitle = "Agent FOMO - Never Miss Again";

export const formatEventTitle = (name: string): string => `${name} - f0mo`;

export const formatEventNotFoundTitle = (
  language: Language,
): string =>
  `${eventPageUiTexts[language]?.eventNotFound ?? "Event not found"} - f0mo`;

const staticPathTitles: Record<string, string> = {
  "/": defaultTitle,
  "/events": "Events - Agent FOMO",
  "/swipe": "Train Your Taste - Agent FOMO",
  "/subscriptions": "Subscriptions - Agent FOMO",
  "/friends": "Friends - Agent FOMO",
  "/settings": "Settings - Agent FOMO",
  "/stats": "Live Stats - Agent FOMO",
  "/promote": "Promote - Agent FOMO",
  "/admin": "Admin - Agent FOMO",
  "/privacy": "Privacy Policy - Agent FOMO",
  "/terms": "Terms and Conditions - Agent FOMO",
  "/accessibility": "Accessibility Statement - Agent FOMO",
  "/docs": "Developer API - Agent FOMO",
  "/payment-success": "Payment Successful - Agent FOMO",
  "/payment-cancelled": "Payment Cancelled - Agent FOMO",
};

const eventTitle = (
  eventData: EventPageData | null | undefined,
  language: Language,
): string => {
  const name = eventData?.event?.structured?.name;
  return name ? formatEventTitle(name) : formatEventNotFoundTitle(language);
};

export const pageTitleForPath = ({
  pathname,
  eventData,
  language,
}: {
  pathname: string;
  eventData?: EventPageData | null;
  language?: Language;
}): string => {
  if (pathname.startsWith("/event/")) {
    return eventTitle(eventData, language ?? "en");
  }
  const matched = Object.entries(staticPathTitles).find(([path]) =>
    path === "/" ? pathname === "/" : pathname.startsWith(path)
  );
  return matched ? matched[1] : defaultTitle;
};
